module.exports = __webpack_public_path__ + "img/power_off.f4d126ff.svg";